import React from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from '../supabase';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requireAdmin = false }) => {
  const [isAuthenticated, setIsAuthenticated] = React.useState<boolean | null>(null);
  const [isAdmin, setIsAdmin] = React.useState<boolean | null>(null);

  React.useEffect(() => {
    const checkAuth = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      setIsAuthenticated(!!user);
      
      if (user) {
        setIsAdmin(user.email === 'pokeshanibusiness@gmail.com');
      } else {
        setIsAdmin(false);
      }
    };
    checkAuth();
  }, []);

  if (isAuthenticated === null || (requireAdmin && isAdmin === null)) {
    return <div>Loading...</div>;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  return isAuthenticated ? (
    <>{children}</>
  ) : (
    <Navigate to="/" replace />
  );
};

export default ProtectedRoute;